import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import gql from 'graphql-tag';
var SupportText = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fragment supportText on ComponentPresentationSupportText {\n    preview\n    content\n    aiText\n    useAiText\n  }\n"])));
export default SupportText;